<p>LexplusSharedLib works!</p>
